
















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';
import { SEARCH_GETTERS_KEYS } from '../../store/search/search.const';
import { StaggeringTransitionGroup } from '../pure';

@Component({
  components: {
    StaggeringTransitionGroup
  },
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components,
      config: CONFIG_GETTERS_KEYS.config,
      resultConfig: CONFIG_GETTERS_KEYS.fallbackFiltersResultConfig
    }),
    ...mapGetters(SUBMODULES_PATHS.search, {
      renderFallbackFilters: SEARCH_GETTERS_KEYS.showFallbackFilters,
      compulsoryFacets: SEARCH_GETTERS_KEYS.compulsoryFacets
    }),
    ...mapState(SUBMODULES_PATHS.search, ['facets'])
  }
})
export default class FallbackFilters extends Vue {
}
